import { styled } from "@mui/material/styles";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import CurrentSubscriptionPlanCard from "./CurrentSubscriptionPlanCard";
import BillingDetailsCard from "./BillingDetailsCard";
import BillingHistoryCard from "./BillingHistoryCard";
import UpgradePlan from "./UpgradePlan";

const Container = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  background: "#fff",
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  transform: "scale(0.97)",
  transformOrigin: "center",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    transform: "scale(0.95)",
    marginTop: theme.spacing(-5),
  },
}));

const Content = styled(Box)<{ component?: React.ElementType }>(({ theme }) => ({
  width: "100%",
  maxWidth: "auto",
  padding: theme.spacing(1),
  marginTop: theme.spacing(0),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0),
    maxWidth: "100%",
    marginTop: theme.spacing(0),
  },
}));

const WelcomeText = styled(Typography)(({ theme }) => ({
  fontSize: "30px",
  fontWeight: 700,
  color: "#4b5b5d",
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

const Plans = () => {
  return (
    <Container>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
        style={{
          width: "100%",
          maxWidth: "auto",
          margin: "0 auto",
        }}
      >
        <Content component="form">
          <WelcomeText>Plans</WelcomeText>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, md: 4 }}>
              <CurrentSubscriptionPlanCard />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <BillingDetailsCard />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <BillingHistoryCard />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12 }}>
              <UpgradePlan />
            </Grid>
          </Grid>
        </Content>
      </motion.div>
    </Container>
  );
};

export default Plans;
